module.exports = __webpack_public_path__ + "img/icon-battle.e8aac8af.svg";